import {CardOnDashboard, ContentType, DashboardCard} from 'common/report/dashboards/types';

export function isDashboardCard(card: CardOnDashboard): card is DashboardCard {
  return card.type === ContentType.Report || card.type === ContentType.ReportLink;
}
